module.exports = __webpack_public_path__ + "img/风暴.be0bcf5a.png";